import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Checklist from '~/containers/Checklist';
import { loadChecklists } from '~/containers/Checklist/actions';
import DrawerChecklist from '~/containers/DrawerChecklist';
import { loadPermissionsGroups } from '~/containers/Permissions/actions';
import { LoadingTopBar } from '~/components/UI/LoadingTopBar';
import Layout from '../components/UI/Layout/Layout';

export const ScreensChecklist = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    try {
      await Promise.all([
        dispatch(loadChecklists({ showLoading: false })),
        dispatch(loadPermissionsGroups({ showLoading: false })),
      ]);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <Checklist />
        <DrawerChecklist />
      </Layout>
    </div>
  );
};
